import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  constructor() { }
  itemValue = new Subject();
  

  set theItem(value) {
  
    this.itemValue.next(value); // this will make sure to tell every subscriber about the change.
    sessionStorage.setItem('branchId', value);
  }

  get theItem() {
    return localStorage.getItem('branchId');
  }
}
